export const notifyMe = (title='New Notification', body='Hey there! You\'ve been notified!', icon='https://vijee.in/logo512.png') => {
    if (Notification.permission !== 'granted') {
        Notification.requestPermission();
    } else {
        const notification = new Notification(title, { icon, body });
        notification.onclick = () => {
            notification.close()
        };
    }
}